import i18n, { Ti18nKeys } from "../../../../../../../constants/i18n";
import { TDescriptionType } from "../../../../../../../Types";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../../core/et3-text";

const DescriptionHeader = withLiteObserverAndTheme<{
  descriptionType: TDescriptionType;
}>((props) => {
  const { theme, descriptionType } = props;
  const { colors, unitX } = theme;
  const isSelfDescription = descriptionType === "self_description";
  const descriptionKey: Ti18nKeys = isSelfDescription
    ? "DESCRIPTION_ABOUT_ME"
    : "DESCRIPTION_ABOUT_MY_PARTNER";

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={370}
      height={37}
      color={colors.all.transparent}
      style={{
        width: "100%",
        borderBottom: `${3 * unitX}px solid ${colors.all.lightGray}`
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={20}
        text={i18n.get(descriptionKey)}
        isSpan={false}
        color={colors.all.maastrichtBlue}
        style={{}}
      />
    </ET3Div>
  );
});

export default DescriptionHeader;
